import React from "react";

export default () => (
    <p style={{ textAlign: "center", margin: "5rem auto" }}>
        <i className="fa fa-exclamation-triangle" style={{ fontSize: "1.5rem", color: "#fbbd2b" }} />
        <br />
        OnPoint is not supported for mobile phones
    </p>
);
